<template>
  <div>
    <v-toolbar class="ml-2 mr-2" elevation="1" height="auto" v-if="!isMobile">
      <v-card-text>
        <v-row flat class="mt-1">
          <v-col cols="12" lg="2" xl="2" md="2" sm="12" xs="12">
            <span class="subtitle-2 primary--text">
              <b>Submitted By</b>
            </span>
            <br />
            <span class="subtitle-2">
              {{ PropItem.user_detail.user_name }}
            </span>
          </v-col>
          <v-col cols="12" lg="2" xl="2" md="2" sm="12" xs="12">
            <span class="subtitle-2 primary--text">
              <b>Expense Name</b>
            </span>
            <br />
            <span class="subtitle-2">
              {{ PropItem.expense_name }}
            </span>
          </v-col>
          <v-col cols="12" lg="2" xl="2" md="2" sm="12" xs="12">
            <span class="subtitle-2 primary--text">
              <b>Total Amount</b>
            </span>
            <br />
            <span class="subtitle-2">
              {{ PropItem.total_amount }}
            </span>
          </v-col>
          <v-col cols="12" lg="2" xl="2" md="2" sm="12" xs="12">
            <span class="subtitle-2 primary--text">
              <b>Submitted On</b>
            </span>
            <br />
            <span class="subtitle-2">
              {{ PropItem.created_on }}
            </span>
          </v-col>
          <v-col cols="12" lg="2" xl="2" md="2" sm="12" xs="12">
            <span class="subtitle-2 primary--text">
              <b>Additional Info</b>
            </span>
            <br />
            <span class="subtitle-2">
              {{ PropItem.additional_info }}
            </span>
          </v-col>
          <v-col cols="12" lg="1" xl="1" md="1" sm="12" xs="12">
            <span class="subtitle-2 primary--text">
              <b>User Type</b>
            </span>
            <br />

            <v-btn
              v-if="UserDetails"
              class="black--text caption ml-n4 mt-n2"
              text
              @click="OpenUsertypeDialog()"
            >
              <u>Click here</u>
            </v-btn>
            <span v-else>-</span>
          </v-col>
          <br />
          <v-spacer></v-spacer>

          <!-- <v-btn
            class="mt-2 elevation-0"
            fab
            dark
            small
            color="primary"
            @click="backbutton()"
          >
            <v-icon dark>mdi-reply</v-icon>
          </v-btn> -->
        </v-row>
      </v-card-text>
    </v-toolbar>
    <v-card
      v-if="isMobile"
      flat
      background="transperent"
      class="elevation-1 ml-2 mr-2 mt-7"
    >
      <!-- <v-btn
        class="mt-2 elevation-0"
        fab
        dark
        x-small
        color="primary"
        @click="backbutton()"
      >
        <v-icon dark>mdi-reply</v-icon>
      </v-btn> -->
      <v-card rounded="xl" style="padding: 10px" class="ma-3">
        <span class="primary--text mt-5 subtitle-2" style="font-size: 16px">
          <b>Submitted By :</b></span
        >
        <span class="black--text" style="font-size: 14px">
          {{ PropItem.user_detail.user_name }}</span
        >
        <br />
        <span class="primary--text mt-5 subtitle-2" style="font-size: 16px">
          <b>Expense Name :</b></span
        >
        <span class="black--text" style="font-size: 14px">
          {{ PropItem.expense_name }}</span
        >
        <br />
        <span class="primary--text mt-5 subtitle-2" style="font-size: 16px">
          <b>Total Amount :</b></span
        >
        <span class="black--text" style="font-size: 14px">
          {{ PropItem.total_amount }}</span
        >
        <br />
        <span class="primary--text mt-5 subtitle-2" style="font-size: 16px">
          <b>Submitted On :</b></span
        >
        <span class="black--text" style="font-size: 14px">
          {{ PropItem.created_on }}</span
        >
        <br />
        <span class="primary--text mt-5 subtitle-2" style="font-size: 16px">
          <b>Additional Info:</b></span
        >
        <span class="black--text" style="font-size: 14px">
          {{ PropItem.additional_info }}</span
        >
        <br />
        <span class="primary--text mt-4 subtitle-2" style="font-size: 16px">
          <b>User Type :</b></span
        >
        <v-btn
          v-if="UserDetails"
          class="black--text caption ml-n4"
          text
          @click="OpenUsertypeDialog()"
        >
          <u>Click here</u>
        </v-btn>
        <span v-else>-</span>
        <br />
      </v-card>
    </v-card>
    <v-card
      v-for="item in expenseList"
      :key="item.title"
      flat
      background="transperent"
      class="elevation-1 ml-2 mr-2 mt-7"
    >
      <v-card-text>
        <v-row>
          <v-col cols="12" xl="3" lg="3" md="3" class="mt-n2">
            <v-card rounded="xl" style="padding: 8px">
              <span class="black--text" style="font-size: 17px">
                <b> TRANSACTION DETAILS </b></span
              ><br />
              <br />
              <span
                class="primary--text mt-5 subtitle-2"
                style="font-size: 16px"
              >
                <b>MERCHANT NAME :</b></span
              >
              <span class="black--text" style="font-size: 14px">
                {{ item.merchant_name }}</span
              >
              <br />

              <span
                class="primary--text mt-5 subtitle-2"
                style="font-size: 16px"
              >
                <b>TXN TYPE :</b></span
              >
              <span class="black--text" style="font-size: 14px">
                {{ item.transaction_details.txn_type }}</span
              >
              <br />

              <span
                class="primary--text mt-5 subtitle-2"
                style="font-size: 16px"
              >
                <b>TXN TIME :</b></span
              >
              <span class="black--text" style="font-size: 14px">
                {{ item.transaction_details.txn_time }}</span
              >
              <br />

              <span
                class="primary--text mt-5 subtitle-2"
                style="font-size: 16px"
              >
                <b>TXN AMOUNT :</b></span
              >
              <span class="black--text" style="font-size: 14px">
                {{ item.transaction_details.txn_amount }}&nbsp;{{
                  item.transaction_details.txn_currency
                }}</span
              >
              <br />
              <span
                class="primary--text mt-5 subtitle-2"
                style="font-size: 16px"
                v-if="item.transaction_details.txn_type == 'CASH_WITHDRAWAL'"
              >
                <b>FEE AMOUNT :</b></span
              >
              <span
                class="black--text"
                style="font-size: 14px"
                v-if="item.transaction_details.txn_type == 'CASH_WITHDRAWAL'"
              >
                {{ item.fee_amount }}</span
              >
              <br
                v-if="item.transaction_details.txn_type == 'CASH_WITHDRAWAL'"
              />
              <span
                class="primary--text mt-5 subtitle-2"
                style="font-size: 16px"
              >
                <b>BILLING AMOUNT :</b></span
              >
              <span class="black--text" style="font-size: 14px">
                {{ item.transaction_details.billing_amount }}&nbsp;MYR</span
              >
              <br />
<!-- 
              <span
                class="primary--text mt-5 subtitle-2"
                style="font-size: 16px"
              >
                <b>MERCHANT CITY :</b></span
              >
              <span class="black--text" style="font-size: 14px">
                {{ item.merchant_city }}</span
              >
              <br /> -->

              <span
                class="primary--text mt-5 subtitle-2"
                style="font-size: 16px"
              >
                <b>MERCHANT COUNTRY :</b></span
              >
              <span class="black--text" style="font-size: 14px">
                {{ item.merchant_country }}</span
              >
              <br />
            </v-card>
            <v-card rounded="xl" style="padding: 8px" class="mt-5">
              <span class="black--text" style="font-size: 17px">
                <b> EXPENSE SUMMARY </b></span
              ><br />
              <br />
              <span
                class="primary--text mt-5 subtitle-2"
                style="font-size: 16px"
              >
                <b>EXPENSE AMOUNT :</b></span
              >
              <span class="black--text" style="font-size: 14px">
                {{ item.currency }}
                {{ item.expense_rules.amount }}</span
              >
              <br />

              <span
                class="primary--text mt-5 subtitle-2"
                style="font-size: 16px"
              >
                <b>EXPENSE USER TYPE :</b></span
              >
              <span class="black--text" style="font-size: 14px">
                {{ item.expense_rules.usertype_name }}</span
              >
              <br />

              <span
                class="primary--text mt-5 subtitle-2"
                style="font-size: 16px"
              >
                <b>EXPENSE RULE :</b></span
              >
              <span class="black--text" style="font-size: 14px">
                {{ item.expense_rules.rule_desc }}</span
              >
              <br />
              <span
                class="primary--text mt-5 subtitle-2"
                style="font-size: 16px"
              >
                <b>EXPENSE RULE SUMMARY :</b></span
              >
              <span class="black--text" style="font-size: 14px">
                {{ item.expense_rules.rule_summary }}</span
              >
              <br />
              <br />
            </v-card>
          </v-col>
          <v-col cols="12" xl="3" lg="3" md="3" class="mt-n2">
            <v-card rounded="xl" style="padding: 8px">
              <span class="black--text" style="font-size: 17px">
                <b> SUBMITTED DETAILS </b></span
              ><br />

              <span
                class="primary--text mt-5 subtitle-2"
                style="font-size: 16px"
                v-if="item.transaction_details.txn_type != 'CASH_WITHDRAWAL'"
              >
                <b>SUBMITTED AMOUNT :</b></span
              >
              <span
                class="black--text"
                style="font-size: 14px"
                v-if="item.transaction_details.txn_type != 'CASH_WITHDRAWAL'"
              >
                {{ item.currency }}
                {{ item.submitted_amount }}</span
              >
              <br />
              <span
                v-if="item.transaction_details.txn_type == 'CASH_WITHDRAWAL'"
                class="primary--text mt-5 subtitle-2"
                style="font-size: 16px"
              >
                <b>SUBMITTED AMOUNT :</b></span
              >
              <span
                class="black--text"
                style="font-size: 14px"
                v-if="item.transaction_details.txn_type == 'CASH_WITHDRAWAL'"
              >
                {{ item.currency }}
                {{ item.cash_withdrawal_total }}</span
              >
              <br
                v-if="item.transaction_details.txn_type == 'CASH_WITHDRAWAL'"
              />

              <span
                class="primary--text mt-5 subtitle-2"
                style="font-size: 16px"
              >
                <b>CATEGORY SELECTED :</b></span
              >
              <span class="black--text" style="font-size: 14px">
                {{ item.category_name }}</span
              >
              <br />

              <span
                class="primary--text mt-5 subtitle-2"
                style="font-size: 16px"
              >
                <b>USER COMMENTS :</b></span
              >
              <span class="black--text" style="font-size: 14px">
                {{ item.user_comments }}</span
              >
              <br />

              <br />
              <span
                class="primary--text mt-5 subtitle-2"
                style="font-size: 16px; text-decoration-line: underline"
              >
                <b>RECIEPT </b></span
              >
              <v-card-actions v-if="item.receipt_url !== null">
                <v-avatar
                  v-for="(item, i) in item.receipt_url"
                  :key="i"
                  :class="{ 'ma-3': i }"
                  size="40"
                >
                  <v-icon
                    v-if="item.includes('webp' || 'WEBP')"
                    size="44"
                    color="primary"
                    @click="openImageInNewTab1(item)"
                    >mdi-image</v-icon
                  >
                  <v-icon
                    v-if="item.includes('jpg' || 'JPG')"
                    size="44"
                    color="primary"
                    @click="openImageInNewTab1(item)"
                    >mdi-image</v-icon
                  >
                  <v-icon
                    v-if="item.includes('jpeg' || 'JPEG')"
                    size="44"
                    color="primary"
                    @click="openImageInNewTab1(item)"
                    >mdi-image</v-icon
                  >
                  <v-icon
                    v-if="item.includes('png' || 'PNG')"
                    size="44"
                    color="primary"
                    @click="openImageInNewTab1(item)"
                    >mdi-image</v-icon
                  >
                  <v-icon
                    v-if="item.includes('docx' || 'doc')"
                    size="40"
                    color="blue"
                    @click="openImageInNewTab(item)"
                    >mdi-file-word</v-icon
                  >
                  <v-icon
                    v-if="item.includes('txt')"
                    size="40"
                    color="blue"
                    @click="openImageInNewTab(item)"
                    >mdi-file-document</v-icon
                  >
                  <v-icon
                    v-if="item.includes('pdf')"
                    size="40"
                    color="red"
                    @click="openImageInNewTab(item)"
                    >mdi-file-pdf</v-icon
                  >

                  <v-icon
                    v-if="item.includes('xls' || 'xlsx')"
                    size="40"
                    color="green"
                    @click="openImageInNewTab(item)"
                    >mdi-file-excel</v-icon
                  >

                  <!-- <v-img
                    alt="Error"
                    accept="/*"
                    :src="item"
                    @click="openImageInNewTab1(item)"
                  ></v-img>  -->
                </v-avatar></v-card-actions
              >
            </v-card>
          </v-col>
          <v-col cols="12" xl="3" lg="3" md="3" class="mt-n2">
            <v-card rounded="xl" style="padding: 8px">
              <span class="black--text" style="font-size: 17px">
                <b> APPROVER 1 DETAILS </b></span
              ><br />
              <br />
              <span
                class="primary--text mt-5 subtitle-2"
                style="font-size: 16px"
              >
                <b>APPROVED AMOUNT :</b></span
              >
              <span class="black--text" style="font-size: 14px">
                MYR {{ item.verified_amount }}</span
              >
              <br />

              <span
                class="primary--text mt-5 subtitle-2"
                style="font-size: 16px"
              >
                <b>STATUS :</b></span
              >
              <span
                class="black--text"
                style="font-size: 14px"
                :class="getColor(item.verifier_status)"
              >
                {{ gettexttostatus(item.verifier_status) }}</span
              >
              <br />

              <span
                class="primary--text mt-5 subtitle-2"
                style="font-size: 16px"
              >
                <b>APPROVED BY :</b></span
              >
              <span class="black--text" style="font-size: 14px">
                {{ item.verified_by }}</span
              >
              <br />
              <span
                class="primary--text mt-5 subtitle-2"
                style="font-size: 16px"
              >
                <b>APPROVED ON :</b></span
              >
              <span class="black--text" style="font-size: 14px">
                {{ item.verified_on }}</span
              >
              <br />

              <span
                class="primary--text mt-5 subtitle-2"
                style="font-size: 16px"
              >
                <b>APPROVED COMMENTS :</b></span
              >
              <span class="black--text" style="font-size: 14px">
                {{ item.verifier_comments }}</span
              >
              <br />
            </v-card>
          </v-col>
          <v-col cols="12" xl="3" lg="3" md="3" class="mt-n2">
            <v-card rounded="xl" style="padding: 8px">
              <span class="black--text" style="font-size: 17px">
                <b> APPROVER 2 DETAILS </b></span
              ><br />
              <br />
              <span
                class="primary--text mt-5 subtitle-2"
                style="font-size: 16px"
              >
                <b>APPROVED AMOUNT :</b></span
              >
              <span class="black--text" style="font-size: 14px">
                MYR {{ item.approved_amount }}</span
              >
              <br />

              <span
                class="primary--text mt-5 subtitle-2"
                style="font-size: 16px"
                v-if="
                  item.verifier_comments != null && item.approval_status1 != 0
                "
              >
                <b>STATUS :</b></span
              >
              <span
                class="black--text"
                style="font-size: 14px"
                :class="getColor(item.approval_status1)"
              >
                {{ gettexttostatus1(item.approval_status1) }}</span
              >
              <br />

              <span
                class="primary--text mt-5 subtitle-2"
                style="font-size: 16px"
              >
                <b>APPROVED BY :</b></span
              >
              <span class="black--text" style="font-size: 14px">
                {{ item.approved_by }}</span
              >
              <br />
              <span
                class="primary--text mt-5 subtitle-2"
                style="font-size: 16px"
              >
                <b>APPROVED ON :</b></span
              >
              <span class="black--text" style="font-size: 14px">
                {{ item.approved_on }}</span
              >
              <br />

              <span
                class="primary--text mt-5 subtitle-2"
                style="font-size: 16px"
              >
                <b>APPROVED COMMENTS :</b></span
              >
              <span class="black--text" style="font-size: 14px">
                {{ item.approver_comments }}</span
              >
              <br />
              <!-- <span
                  class="primary--text mt-5 subtitle-2"
                  style="font-size: 16px"
                  v-if="item.approval_status == 3 || item.approval_status == 4"
                >
                  <b>APPROVED AMOUNT :</b></span
                >
                <span
                  class="black--text"
                  style="font-size: 14px"
                  v-if="item.approval_status == 3 || item.approval_status == 4"
                >
                  MYR {{ item.approved_amount }}</span
                >
                <br /> -->
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-dialog class="overflow-hidden" v-model="arraylistStatus" fullscreen>
      <v-card>
        <v-card-title dense flat>
          <v-spacer></v-spacer>
          <v-btn fab x-small color="red" @click="arraylistStatus = false">
            <v-icon color="white">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text align="center" justify="center">
          <v-img
            class="zoomed-out-image"
            height="auto"
            :src="urlArrry"
            width="400"
            @click="openinWindow(urlArrry)"
          >
            <template v-slot:placeholder>
              <v-row class="fill-height ma-0" align="center" justify="center">
                <v-progress-circular
                  indeterminate
                  color="primary"
                  size="100"
                ></v-progress-circular>
              </v-row>
            </template>
          </v-img>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="loader" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text class="pt-2">
          {{ loaderMsg }}
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="usertypeDialog" max-width="600">
      <v-card>
        <v-toolbar flat class="header" dense dark>
          <span class="ml-3">User Type Details</span>

          <v-spacer></v-spacer>
          <v-btn class text dark @click="usertypeDialog = false">
            <v-icon small color="white" class="ml-8"> mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-card
            elevation="1"
            width="600"
            height="auto"
            class="mb-4 mt-6"
            shaped
          >
            <v-row>
              <v-col cols="12" md="6" lg="6" xl="6">
                <v-row class="ml-3">
                  <v-col cols="12" md="12" lg="12">
                    <span class="subtitle-2">
                      <b class="primary--text">User Type Name</b>
                    </span>
                    <br />
                    <span
                      class="caption"
                      v-if="UserDetails.user_type_name != null"
                    >
                      {{ UserDetails.user_type_name }}
                    </span>
                    <span class="caption ml-2" v-else> - </span>
                  </v-col>
                </v-row>
                <v-row class="ml-3">
                  <v-col cols="12" md="12" lg="12">
                    <span class="subtitle-2">
                      <b class="primary--text">Role Name</b>
                    </span>
                    <br />
                    <span class="caption" v-if="UserDetails.role_name != null">
                      {{ UserDetails.role_name }}
                    </span>
                    <span class="caption ml-2" v-else> - </span>
                  </v-col>
                </v-row>
              </v-col>

              <v-col cols="12" md="6" lg="6" xl="6">
                <v-row class="ml-3">
                  <v-col cols="12" md="12" lg="12">
                    <span class="subtitle-2">
                      <b class="primary--text">Grade Name</b>
                    </span>
                    <br />
                    <span class="caption" v-if="UserDetails.grade_name != null">
                      {{ UserDetails.grade_name }}
                    </span>
                    <span class="caption ml-2" v-else> - </span>
                  </v-col>
                </v-row>
                <v-row class="ml-3">
                  <v-col cols="12" md="12" lg="12">
                    <span class="subtitle-2">
                      <b class="primary--text">Location </b>
                    </span>
                    <br />
                    <span class="caption" v-if="UserDetails.location != null">
                      {{ UserDetails.location }}
                    </span>
                    <span class="caption ml-2" v-else> - </span>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { apiCall } from "@/Views/APICALL/APIcall.js";

export default {
  data: () => ({
    expenseList: [],
    urlArrry: [],
    actionDialogeStatus: false,
    arraylistStatus: false,
    step: 1,
    titleAction: "",

    nameRules: [(v) => !!v || "Required"],
    commentExpense: "",
    approved_amount: 0,
    loader: false,
    loaderMsg: "Please stand by",
    verified_amount: 0,
    receipt: "",
    numberRules: [
      (x) => /^[0-9]\d*(\.\d+)?$/.test(x) || "Enter only numbers",
      (x) => /^(?!0{1})/.test(x) || "Enter Amount Greater Than 0",
      [(v) => !!v || "Required"],
    ],
    error: false,
    max_amount: "",
    itemAction: "",
    redcolor: "",
    usertypeDialog: false,
    pdf: "",
    image: "",
    doc: "",
    xls: "",
    txt: "",
    UserDetails: {},
  }),
  props: {
    ExpenseList: Array,
    expenseid: String,
    PropItem: Object,
  },
  mounted() {
    this.callexpenseList();
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.xsOnly;
    },
  },
  watch: {
    ExpenseList(val) {
      // console.log(this.Approvertypecheck);

      this.expenseList = val;
      if (
        this.expenseList[0].user_type_details != null &&
        this.expenseList[0].user_type_details != ""
      ) {
        this.UserDetails = this.expenseList[0].user_type_details;
      }

      this.expenseList.filter((item) => {
        this.receipt = item.receipt_url;
        for (const item of this.receipt) {
          this.ExtName = require("path").extname(item).replace(".", "");
        }
        // console.log("  this.receipt", this.receipt);
      });

      // if (
      //   this.ExtName == "jpg" ||
      //   this.ExtName == "jpeg" ||
      //   this.ExtName == "png" ||
      //   this.ExtName == "JPG" ||
      //   this.ExtName == "JPEG" ||
      //   this.ExtName == "PNG" ||
      //   this.ExtName == "webp"
      // ) {
      //   this.image = item;
      // }
      // if (this.ExtName == "doc" || this.ExtName == "docx") {
      //   this.doc = item;
      // }
      // if (this.ExtName == "xls" || this.ExtName == "xlsx") {
      //   this.xls = item;
      // }
      // if (this.ExtName == "txt") {
      //   this.txt = item;
      // }

      this.approvertypecheck = this.Approvertypecheck;
    },
  },
  methods: {
    // backbutton() {
    //   this.$emit("backOn");
    // },
    openinWindow(url) {
      window.open(url, "_blank");
    },
    openImageInNewTab1(item) {
      this.urlArrry = [];
      this.urlArrry = item;
      // console.log("asdasd", this.urlArrry);
      // for (const item of this.receipt) {
      //   this.ExtNameNew = require("path").extname(item).replace(".", "");
      // }
      // console.log("Adasdasdasd", this.ExtNameNew);
      this.arraylistStatus = true;

      // window.open(url, "_blank");
    },
    openImageInNewTab(item) {
      window.open(item, "_blank");

      // window.open(url, "_blank");
    },

    getColor(itemAction) {
      if (itemAction == "1") {
        return "font-weight-medium green--text";
      } else if (itemAction == "2") {
        return "font-weight-medium red--text";
      } else if (itemAction == "3") {
        return "font-weight-medium pink--text";
      } else if (itemAction == "4") {
        return "font-weight-medium blue--text";
      } else if (itemAction == "5") {
        return "font-weight-medium blue--text";
      } else if (itemAction == "6") {
        return "font-weight-medium blue--text";
      } else if (itemAction == "7") {
        return "font-weight-medium blue--text";
      }
    },

    gettexttostatus(itemAction) {
      //  console.log("itemAction", itemAction);
      if (itemAction == "1") {
        return "Approved";
      } else if (itemAction == "3") {
        return "Partially Approved";
      } else if (itemAction == "2") {
        return "Rejected";
      } else if (itemAction == "4") {
        return "Recoverd Amount";
      } else if (itemAction == "5") {
        return "Personal";
      } else if (itemAction == "6") {
        return "Official";
      }
    },
    gettexttostatus1(itemAction) {
      //  console.log("itemAction", itemAction);
      if (itemAction == "1") {
        return "Approved";
      } else if (itemAction == "3") {
        return "Partially Approved";
      } else if (itemAction == "2") {
        return "Rejected";
      } else if (itemAction == "4") {
        return "Recoverd Amount";
      } else if (itemAction == "5") {
        return "Rejected By Approver 1";
      } else if (itemAction == "6") {
        return "Personal";
      } else if (itemAction == "7") {
        return "Official";
      }
    },
    async callexpenseList() {
      this.overlay = true;
      // console.log("this.itemfield.expense_id,", this.itemfield.expense_id);
      var inputData = {
        method_name: "EXPENSE",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "GEXPTXN",
          expense_id: this.expenseid,
        },
      };
      var responseData = await apiCall(inputData);
      if (responseData.data.status == "00") {
        if (responseData.data.data != null) {
          this.expenseList =
            responseData.data.data == null ? [] : responseData.data.data;

          for (let i = 0; i < responseData.data.data.length; i++) {
            this.userdetails = responseData.data.data[i].user_type_details;
          }

          this.expenseList.forEach((element) => {
            element.approval_status1 =
              this.approvertypecheck == "1"
                ? element.verifier_status
                : element.approval_status;

            element.userdetails = element.user_type_details;
          });
        }
      }

      this.overlay = false;
    },
    OpenUsertypeDialog() {
      this.usertypeDialog = true;
    },
  },
};
</script>
